/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HipaaToggle/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function HipaaToggle({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Topbar/Content/SettingsAction/Settings/HipaaToggle"
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let tabSelectedHipaaActiveValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.hipaa_active',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="HipaaToggle.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Zmjxlu': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 marginTop={0}
 width="100%"
 justifyContent="space-between"
 data="tab.selected.hipaa_active"
 value={tabSelectedHipaaActiveValueData}
 onChange={onChange}
>
{childProps => (
<React.Fragment>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text="Hide last name of patients"
 size="normal"
 weight="regular"
/>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
</React.Fragment>
)}
</TysiaToggle>
</div>
{children}
</React.Fragment>)
}